var $imports = require("../../../../../node_modules/art-template/lib/runtime.js");
module.exports = function ($data) {
    'use strict';
    $data = $data || {};
    var $$out = '', isDTRuntime = $data.isDTRuntime, $escape = $imports.$escape, feedback = $data.feedback, foxitSoftware = $data.foxitSoftware, eduExclusive = $data.eduExclusive, helpCenter = $data.helpCenter, updateLogs = $data.updateLogs, downloadClient = $data.downloadClient, downloadClientCN = $data.downloadClientCN, foxitPlugIns = $data.foxitPlugIns;
    $$out += '    <paddle exclude-devices="tablet" name="fv--help-tab-paddle" @lazy-content="shown">\n        <group-list name="help-toolbar-group-list">\n            ';
    if (!isDTRuntime) {
        $$out += '\n            <group name="help-tab-group-feedback" retain-count="1">\n                <ribbon-button class="fv__ui-toolbar-show-text-button" @tooltip tooltip-title=';
        $$out += $escape(feedback.tooltip);
        $$out += ' name="';
        $$out += $escape(feedback.name);
        $$out += '" icon-class="';
        $$out += $escape(feedback.icon);
        $$out += '" text="';
        $$out += $escape(feedback.title);
        $$out += '" @cannotBeDisabled></ribbon-button>\n            </group>\n            ';
    }
    $$out += '\n            <group name="help-tab-group-foxit-software" retain-count="1">\n                <ribbon-button class="fv__ui-toolbar-show-text-button" @tooltip tooltip-title=';
    $$out += $escape(foxitSoftware.tooltip);
    $$out += ' name="';
    $$out += $escape(foxitSoftware.name);
    $$out += '" icon-class="';
    $$out += $escape(foxitSoftware.icon);
    $$out += '" text="';
    $$out += $escape(foxitSoftware.title);
    $$out += '" @cannotBeDisabled></ribbon-button>\n            </group>\n            <group name="help-tab-group-edu-exclusive" retain-count="1">\n                <ribbon-button class="fv__ui-toolbar-show-text-button" @tooltip tooltip-title=';
    $$out += $escape(eduExclusive.tooltip);
    $$out += ' name="';
    $$out += $escape(eduExclusive.name);
    $$out += '" icon-class="';
    $$out += $escape(eduExclusive.icon);
    $$out += '" text="';
    $$out += $escape(eduExclusive.title);
    $$out += '" @cannotBeDisabled></ribbon-button>\n            </group>\n            <group name="help-tab-group-help-center" retain-count="1">\n                <ribbon-button class="fv__ui-toolbar-show-text-button" @tooltip tooltip-title=';
    $$out += $escape(helpCenter.tooltip);
    $$out += ' name="';
    $$out += $escape(helpCenter.name);
    $$out += '" icon-class="';
    $$out += $escape(helpCenter.icon);
    $$out += '" text="';
    $$out += $escape(helpCenter.title);
    $$out += '" @cannotBeDisabled></ribbon-button>\n            </group>\n            <group name="help-tab-group-update-logs" retain-count="1">\n                <ribbon-button class="fv__ui-toolbar-show-text-button" @tooltip tooltip-title=';
    $$out += $escape(updateLogs.tooltip);
    $$out += ' name="';
    $$out += $escape(updateLogs.name);
    $$out += '" icon-class="';
    $$out += $escape(updateLogs.icon);
    $$out += '" text="';
    $$out += $escape(updateLogs.title);
    $$out += '" @cannotBeDisabled></ribbon-button>\n            </group>\n            <group name="help-tab-group-download-client" retain-count="1">\n                <ribbon-button class="fv__ui-toolbar-show-text-button" @tooltip tooltip-title=';
    $$out += $escape(downloadClient.tooltip);
    $$out += ' name="';
    $$out += $escape(downloadClient.name);
    $$out += '" icon-class="';
    $$out += $escape(downloadClient.icon);
    $$out += '" text="';
    $$out += $escape(downloadClient.title);
    $$out += '" @cannotBeDisabled></ribbon-button>\n            </group>\n            <group name="help-tab-group-download-client-cn" retain-count="1">\n                <ribbon-button class="fv__ui-toolbar-show-text-button" @tooltip tooltip-title=';
    $$out += $escape(downloadClientCN.tooltip);
    $$out += ' name="';
    $$out += $escape(downloadClientCN.name);
    $$out += '" icon-class="';
    $$out += $escape(downloadClientCN.icon);
    $$out += '" text="';
    $$out += $escape(downloadClientCN.title);
    $$out += '" @cannotBeDisabled></ribbon-button>\n            </group>\n            <group name="help-tab-group-foxit-plug-ins" retain-count="1">\n                <ribbon-button class="fv__ui-toolbar-show-text-button" @tooltip tooltip-title=';
    $$out += $escape(foxitPlugIns.tooltip);
    $$out += ' name="';
    $$out += $escape(foxitPlugIns.name);
    $$out += '" icon-class="';
    $$out += $escape(foxitPlugIns.icon);
    $$out += '" text="';
    $$out += $escape(foxitPlugIns.title);
    $$out += '" @cannotBeDisabled></ribbon-button>\n            </group>\n        </group-list>\n    </paddle>';
    return $$out;
};